<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="main">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/horse-walk/horse-walk_1-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/horse-walk/horse-walk_1-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/horse-walk/horse-walk_1-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/horse-walk/horse-walk_1-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/horse-walk/horse-walk_1.jpg`" />
            </picture>
          </foreignObject>
          <g class="hair">
            <image width="2027" height="1089" x="698" y="607" :xlink:href="`${publicPath}scenes/horse-walk/horse-walk_2.png`"/>
            <image width="2032" height="1060" x="712" y="617" :xlink:href="`${publicPath}scenes/horse-walk/horse-walk_3.png`"/>
            <image width="2106" height="1078" x="675" y="627" :xlink:href="`${publicPath}scenes/horse-walk/horse-walk_4.png`"/>
            <image width="2115" height="1055" x="668" y="631" :xlink:href="`${publicPath}scenes/horse-walk/horse-walk_5.png`"/>
          </g>
        </g>
      </g>
    </svg>
    <SceneDialogue
      :ref="`dialogue`"
      :width=".3"
      :tx="1" :ty="0.6">
      I think it was right around the War Years when Max took his brothers to
      Barstow, California. They went to stock ammunition and load trains. It
      reminded Max of when he was in the U.S. Cavalry while he was at Haskell.
      He was always helping wherever he could.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/horse-walk/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0, transformOrigin: "center center"})
    TweenLite.set(d, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 1, {opacity: 1, scale: 1, x: "0%"}), 0.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()}
  },
  props: ["slide"]
}
</script>

<style lang="scss" scoped>
.hair {
  image {
    animation: hair 0.8s infinite;
    animation-timing-function: steps(0, end);
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.2s; }
    &:nth-of-type(3) { animation-delay: -.4s; }
    &:nth-of-type(4) { animation-delay: -.6s; }
  }
}

@keyframes hair {
  0% { opacity: 1 }
  25% { opacity: 0 }
  50% { opacity: 0 }
}
</style>
